module.exports = __webpack_public_path__ + "img/dnd_logo_custom.f1b0b3e2.png";